<template>
  <div>
    <div id="topbar">
      <div class="container container--base nav-bar-zamaknjeno">
        <div class="content">
          <div id="topbar__left">
            <div id="header__logo">
              <a href="https://www.t-2.net" title="T-2: Tako, kot mora biti">
                <img src="./T-2_files/T2_logo_new.png" alt="logotip T2 tako, kot mora biti" title="SPLETNA STRAN T-2">
              </a>
            </div>
            <div id="block-bean-zgornji-linki" class="block block-bean">
              <div class="ds-1col entity entity-bean bean-top-header view-mode-default clearfix">
                <div class="field field-name-custom-link field-type-ds field-label-hidden">
                  <div class="field-items">
                    <div class="field-item even">
                      <ul class="list list--topbar">
                        <li class="list__node list__node--topbar">
<!--                          <a title="MOJ-T2" href="/Domov/NaslovnaStran">MOJ T-2</a>-->
                          <router-link :to="{name: povezave.NAME_NASLOVNA_STRAN}" class="napis-mobile">
                            MOJ T-2
                          </router-link>
                        </li>
                        <li class="list__node list__node--topbar ">
                          <a title="TV2GO" href="https://tv2go.t-2.net/">TV2GO</a>
                        </li>
                        <li class="list__node list__node--topbar ">
                          <a title="T2-KLUB" href="https://klub.t-2.net/">T-2 KLUB</a>
                        </li>
                        <li class="list__node list__node--topbar ">
                          <a title="HRAMBA" href="https://avditorij.t-2.net/">AVDITORIJ</a>
                        </li>
                        <li class="list__node list__node--topbar ">
                          <a title="ePOŠTA" href="https://webmail.t-2.net/">ePOŠTA</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="topbar__right">
            <div class="userAccount">
              <div class="user--login">
                <div id="user-div">
                  <img v-if="izbranaSlika !== null" id="t2userpicture" style="display: inline-block;" :src="izbranaSlika">
                  <div id="t2username"></div>
                </div>
                <span>
                    <button id="t2logoutbtn" style="display: inline-block;">
                       Odjavite se
                    </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <header id="header">
      <div class="container container--base nav-bar-zamaknjeno">
        <div class="content">
          <div
            v-if="showHamburgerMenu"
            id="header__hamburger"
            :class="{'navbar-toggle': true, toggled: $sidebar.showSidebar}"
            style="margin-top: 22px;"
            @click="ToggleSidebar"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar bar1"></span>
            <span class="icon-bar bar2"></span>
            <span class="icon-bar bar3"></span>
          </div>
          <router-link :to="{name: povezave.NAME_NASLOVNA_STRAN}" class="napis-mobile" style="margin-top: 18px !important;">
            MOJ T-2
          </router-link>
          <div id="header__support">
            <span data-v-715dd82a="" class="label label--header__support">24/7 pomoč</span>
            <span class="cta cta--header__support">
              <a :href="'tel:' + kontaktniPodatki.T2_SUPPORT_TEL_ST" class="cta cta--cart__support">
                {{kontaktniPodatki.T2_SUPPORT_TEL_ST}}
              </a>
            </span>
          </div>
          <nav id="header__nav">
            <ul class="list list--header__nav">
              <li class="leaf list__node list__node--header__nav">
                <a :href="povezave.BASE_URL_MAGAZIN" target="_blank">T-2 Magazin</a>
              </li>
              <li class="leaf has-children list__node list__node--header__nav">
                <a :href="povezave.BASE_URL_POSLOVALNICE" target="_blank">Poslovalnice</a>
              </li>
              <li class="leaf has-children list__node list__node--header__nav">
                <a :href="povezave.BASE_URL_PODPORA" target="_blank">Podpora naročnikom</a>
              </li>
            </ul>
          </nav>
          <div id="submenuTrigger" @click="PrikaziBliznjice"></div>
        </div>
      </div>

      <div class="mobileTopBarElements">
        <div class="mobileTopBarElements--wrapper">
          <div class="menu-block-wrapper menu-block-62 menu-name-menu-quicklinks parent-mlid-0 menu-level-1">
            <ul class="menu">
              <li class="leaf menu__item--t2_logo"><a href="https://www.t-2.net/">Moj T-2</a></li>
              <li class="leaf menu__item--klub"><a href="https://klub.t-2.net/">T-2 Klub</a></li>
              <li class="leaf menu__item--tvgo"><a href="https://tv2go.t-2.net/">TV2GO</a></li>
              <li class="leaf menu__item--hramba"><a href="https://avditorij.t-2.net/index.php/apps/avditorij">T2 Hramba</a></li>
              <li class="last leaf menu__item--email"><a href="https://webmail.t-2.net/">ePošta</a></li>
              <li class="last leaf menu__item--magazin"><a href="https://www.t-2.net/t-2-magazin/vse">Magazin</a></li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>

  import $ from 'jquery'
  import Vue from 'vue'
  import ClientAgent from '../../../assets/js/clientAgent.js'
  import { Radio, RadioGroup, Switch, Button, Table, TableColumn, Form, FormItem, Alert, Icon, Collapse,
    RadioButton, Menu, Submenu, MenuItem, MenuItemGroup } from 'element-ui'
  import {KontaktniPodatkiEnum} from '../../../assets/js/Enum/KontaktniPodatkiEnum.js'
  import {povezave} from '../../../assets/js/Povezave/povezave'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Form)
  Vue.use(FormItem)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(Alert)
  Vue.use(Switch)
  Vue.use(Icon)
  Vue.use(Collapse)
  Vue.use(RadioButton)
  Vue.use(Menu)
  Vue.use(Submenu)
  Vue.use(MenuItem)
  Vue.use(MenuItemGroup)
  export default {
    props: {
      toggleZapiranjeCounter: {
        type: Number,
        default: 0
      },
      showHamburgerMenu: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        clientAgent: null,
        activeNotifications: false,
        isCollapse: true,
        prikazanDesniMeni: '',
        kontaktniPodatki: '',
        izbranaSlika: null,
        povezave: povezave
      }
    },
    components: {
      [Button.name]: Button
    },
    mounted () {
      this.clientAgent = new ClientAgent()
      this.kontaktniPodatki = KontaktniPodatkiEnum
      this.clientAgent.t2Auth.initGUI()
      this.clientAgent.t2Auth.displayLogoutButtons()
      this.izbranaSlika = this.PridobiAvatar()
      this.$root.$on('posodobitevSlikeHandler', () => {
        this.izbranaSlika = this.PridobiAvatar()
      })
    },
    watch: {
      toggleZapiranjeCounter: function () {
        this.HideSidebar()
      }
    },
    methods: {
      PrikaziBliznjice () {
        this.$sidebar.displaySidebar(false)
        $('.mobileTopBarElements').slideToggle()
      },
      ToggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
        if (!this.$sidebar.showSidebar) {
          for (let i = 0; i < this.$sidebar.sidebarLinks.length; i++) {
            Vue.set(this.$sidebar.sidebarLinks[i], 'collapsed', true)
          }
        }
        $('.mobileTopBarElements').hide()
      },
      HideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      HandleClose (key, keyPath) {
      }
    }
  }

</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Open+Sans');
#login-form-div{
  max-width:500px;
  position: fixed;
  top: 35%;
  left: 15%;
}
</style>
<style scoped src="../../../../static/css/TopNavbar.css?">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue